// Antd
import { Avatar } from 'antd';

// React
import { useMemo } from 'react';

// Interfaces
import { ISharedPhotoProfile } from './interfaces';

const SharedPhotoProfile = ({ authenticatedUser, isExpanded, isSidebar }: ISharedPhotoProfile) => {
  // Hook
  const size = useMemo(() => {
    return isSidebar ? 68 : isExpanded ? 48 : 39;
  }, [isExpanded, isSidebar]);

  return authenticatedUser.profilePhoto ? (
    <img
      src={authenticatedUser.profilePhoto!}
      alt={authenticatedUser.name!}
      style={{
        width: size,
        height: size,
        borderRadius: 50,
        objectFit: 'cover',
      }}
    />
  ) : (
    <Avatar size={size}>{authenticatedUser?.name?.split(' ')?.[0]?.[0]}</Avatar>
  );
};

export { SharedPhotoProfile };
